<div class="td-wb-brightcove-player-overlay__content">
  <ng-content />
</div>
